<template>
<div>
    <div class="memu-box">
        <img src="../../static/img/logo.png" class="logo" />
        <div class="menu-icon" :class="{'menu-openning':isOpenning}" @click="openMenu"></div>
    </div>
    <div class="fixed-nav" :style="vh" :hidden="!isOpenning" @click="openMenu">
        <ul>
            <li v-for="(item,index) in menu_text" :key="index"><a :href="'#/'+item.link">{{item.text}}</a></li>
        </ul>
    </div>

</div>
</template>

<script>
export default {
    name: 'head',
    data(){
        return {
            isOpenning:false,
            vh:'height:100%;',
            menu_text:[
                {
                        text: '公司首页',
                        link: 'Main',
                        onOff: true,
                    },
                    {
                        text: '关于我们',
                        link: 'aboutus',
                        onOff: false,
                    },
                    {
                        text: '新闻中心',
                        link: 'newsList',
                        onOff: false,
                    },
                    {
                        text: '党群工作',
                        link: 'dangQun',
                        onOff: false,
                    },
                    {
                        text: '主营业务',
                        link: 'Business',
                        onOff: false,
                    },
                    {
                        text: '专业服务',
                        link: 'Serve',
                        onOff: false,
                    },
                    {
                        text: '企业文化',
                        link: 'Culture',
                        onOff: false,
                    },
                    {
                        text: '人才招聘',
                        link: 'Recruit',
                        onOff: false,
                    },
                    {
                        text: '联系我们',
                        link: 'Relationus',
                        onOff: false,
                    },
                    {
                        text: '登录',
                        link: 'login',
                        onOff: false,
                    }
            ]
        }
    },
    methods:{
        openMenu:function(){
            this.isOpenning=!this.isOpenning;
        }
    },
    mounted(){
        //fixed-nav
        //console.log(document.querySelector(".memu-box").offsetHeight);
        var wh=window.innerHeight;
        var vh=wh-document.querySelector(".memu-box").offsetHeight;
        this.vh="height:"+vh+"px";
    },
    created(){
        
    }
}
</script>

<style>
 @import url('../assets/css/pubcss.css');
 @import url('../assets/css/index.css');

</style>



// WEBPACK FOOTER //
// src/components/myHead.vue